export const formatCpf = (cpf: string) => {
    if (cpf.length !== 11) {
        return cpf; // Retorna o CPF sem máscara se não tiver 11 dígitos
    }
    const numbers = cpf.replace(/\D/g, '');
    return numbers.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
    );
};